import 'components/ckeditor.tag'
riot.tag2('seo-var-macro-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Добавить/изменить макропеременную</div>\n    </yield>\n    <yield to="body">\n      <loader if="{loader}"></loader>\n      <form if="{!loader}" onchange="{change}" onkeyup="{change}">\n        <div class="form-group {has-error: error.name}" if="{!item.id}">\n          <label class="control-label"> Наименование</label>\n          <input class="form-control" name="name" type="text" value="{item.name}">\n          <div class="help-block">{error.name}</div>\n        </div>\n        <div class="form-group">\n          <label class="control-label"> Значение</label>\n          <textarea class="form-control" name="value" value="{item.value}" style="min-height: 150px;"></textarea>\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit}" type="button">Сохранить</button>\n    </yield>\n  </bs-modal>\n', '', '', function(opts) {
'use strict';

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var self = this;

self.on('mount', function () {
    var modal = self.tags['bs-modal'];

    modal.error = false;
    modal.item = {};
    modal.mixin('validation');
    modal.mixin('change');
    //modal.update()

    modal.rules = {
        name: 'empty'
    };

    modal.afterChange = function (e) {
        var name = e.target.name;
        delete modal.error[name];
        modal.error = (0, _extends3.default)({}, modal.error, modal.validation.validate(modal.item, modal.rules, name));
    };

    if (opts.id) {
        modal.loader = true;
        API.request({
            object: 'SeoVariable',
            method: 'Info',
            data: { id: opts.id },
            success: function success(response) {
                modal.item = response;
            },
            complete: function complete() {
                modal.loader = false;
                modal.update();
            }
        });
    }
});
});


// WEBPACK FOOTER //
// ./pages/settings/seo-vars/seo-var-macro-modal.tag